import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useState } from "react";
import { ModalStates } from "../states/ModalStates";

const CopyRequestId = ({ requestId }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(requestId).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [requestId]);

  return (
    <div className="mt-1 small text-muted">
      Request ID: {requestId}{" "}
      <button
        type="button"
        className="btn btn-link btn-sm shadow-none p-0 ml-1 text-muted"
        onClick={handleCopy}
        title="Copy Request ID"
      >
        <FontAwesomeIcon icon={copied ? "far fa-check" : "far fa-copy"} />
      </button>
    </div>
  );
};

const ErrorState = ({ state }) => (
  <div className="card mb-2">
    <div className="card-header">
      {state.status === ModalStates.ERROR && (
        <FontAwesomeIcon
          icon="far fa-times-circle"
          className="mr5 text-danger"
        />
      )}

      {state.inputText}
    </div>

    <div className="card-body">
      <div className="text-danger">{state.message}</div>
      {state.requestId && <CopyRequestId requestId={state.requestId} />}
    </div>
  </div>
);

export default ErrorState;
